/* Particulate Matter: Sheet!PM Emissions*/
import { range } from 'd3-array'
import { curry } from 'lodash';
import { createSelector } from 'reselect';

import {
  getNumProjectionYears,
} from '../../selectors';
import { PROJECTION_START_YEAR } from '../index';

// Array with each year to do a projection for
const getProjectionYearSeries = createSelector([
  getNumProjectionYears,
],
  (numYears) => {
    return range(PROJECTION_START_YEAR, PROJECTION_START_YEAR + numYears + 1) // number[]
  }
)

// B60:// growth is exponential, aka y = ab^x
// TODO: Factor this out as constants
const exponentialGrowth = curry((year: number, a: number, b: number) => a * Math.pow(b, year));

export const getGasolinePMEmissionsPerKm = createSelector([
  getProjectionYearSeries,
],
  (yearSeries) => {
    return yearSeries.map(
      year => {
        const emittedThisYear = exponentialGrowth(year); // partially apply the year
        return {
          autoRickshaw: {
            commercial: emittedThisYear(8.612846942E+21, 0.974027111)
          },
          car: {
            commercial: emittedThisYear(1.796800967E+39, 0.955280811),
            private: emittedThisYear(1.12289222378028E+54, 0.938739256)

          },
          publicTransit: {
            bus: emittedThisYear(2.323191881E+26, 0.9701810725),
          },
          twoWheel: {
            commercial: emittedThisYear(1.383904558E+35, 0.959326545),
            private: emittedThisYear(1.383904558E+35, 0.959326545),
          }
        }
      }
    )
  }
)

export const getDieselPMEmissionsPerKm = createSelector([
  getProjectionYearSeries,
],
  (yearSeries) => {
    return yearSeries.map(
      year => {
        const emittedThisYear = exponentialGrowth(year); // partially apply the year
        return {
          autoRickshaw: {
            commercial: emittedThisYear(1.747268125E+51, 0.942465107)
          },
          car: {
            commercial: emittedThisYear(5.526554085E+39, 0.9556231955),
            private: emittedThisYear(9.918710593E+66, 0.9255396257)
          },
          publicTransit: {
            bus: emittedThisYear(2.081045963E+39, 0.956532551),
          },
        }
      }
    )
  }
)

// Clean natural gas
export const getCNGPMEmissionsPerKm = createSelector([
  getProjectionYearSeries,
],
  (yearSeries) => {
    return yearSeries.map(
      year => {
        const emittedThisYear = exponentialGrowth(year); // partially apply the year
        return {
          autoRickshaw: {
            commercial: emittedThisYear(1.25E+52, 0.94045086)
          },
          car: {
            commercial: emittedThisYear(7.37E+44, 0.948757035),
            private: emittedThisYear(2.51E+68, 0.92297755),
          },
          publicTransit: {
            bus: emittedThisYear(3.67247029E+38, 0.956076562),
          },
        }
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/store/selectors/pmPollution/pmEmissionRate.ts